// views.app.reports.cloudInfrastructure

export const CLOUD_INFRASTRUCTURE = {
  title: 'Cloud Infrastructure'
};
